{
  "build_id": "35c01e68bd",
  "build_timestamp": 1788981843000,
  "environment": "prod",
  "version": "release-bw-tf-4.1.5"
}
